import { toast } from 'sonner';

/**
 * Extract and display a meaningful error message from an API error response.
 * Handles: plain string detail, Pydantic validation arrays, and fallback.
 */
export function showApiError(err, fallbackMsg = 'Operation failed') {
  const detail = err?.response?.data?.detail;
  if (!detail) {
    toast.error(fallbackMsg);
    return;
  }
  if (typeof detail === 'string') {
    toast.error(detail);
  } else if (Array.isArray(detail)) {
    // Pydantic/FastAPI validation errors
    const msgs = detail.map(e => {
      const field = (e.loc || []).filter(l => l !== 'body').pop() || 'field';
      return `${field}: ${e.msg}`;
    });
    toast.error(`Validation error — ${msgs.join('; ')}`);
  } else {
    toast.error(fallbackMsg);
  }
}
